import React, {Children} from 'react';
import {Box} from "@mui/material";

import {ResourceCard} from "../resourceCard/ResourceCard";
import {ResourceCardType} from "../resourceCard/resourceCard-helpers";
import {styles} from "./forPatientsAndCaregivers-helpers";

export const ResourceCards = ({ cards }: { cards: ResourceCardType[] }) => {
    return (
        <Box sx={styles.resourceCardListWrapper}>
            {Children.toArray(cards.map((cardDefinition: ResourceCardType) => {
                return (<ResourceCard {...cardDefinition}  />)
            }))}
        </Box>
    )
}
